import Menu from 'ant-design-vue/es/menu';
// import BScroll from 'better-scroll';

const { Item, SubMenu } = Menu;

function findKeys(source, pid) {
  const result = [];
  function polling(id) {
    if (id) {
      result.push(id);
      const menu = source.find((item) => item.id === id);
      if (menu) {
        polling(menu.parentId);
      }
    }
  }
  polling(pid);
  return result;
}
export default {
  name: 'SMenu',
  props: {
    // 树状层级菜单
    menu: {
      type: Array,
      default: () => [],
      required: true,
    },
    // 无树状普通数组菜单数据
    normalMenu: {
      type: Array,
      default: () => [],
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    mode: {
      type: String,
      required: false,
      default: 'inline',
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: [],
    };
  },
  computed: {
    rootSubmenuKeys: (vm) => {
      const keys = [];
      vm.menu.forEach((item) => keys.push(item.path));
      return keys;
    },
  },
  mounted() {
    this.updateMenu();
  },
  watch: {
    collapsed(val) {
      if (val) {
        this.cachedOpenKeys = this.openKeys.concat();
        this.openKeys = [];
      } else {
        this.openKeys = this.cachedOpenKeys;
      }
    },
    $route() {
      this.updateMenu();
    },
  },
  methods: {
    // select menu item
    onOpenChange(openKeys) {
      // 在水平模式下时执行，并且不再执行后续
      if (this.mode === 'horizontal') {
        this.openKeys = openKeys;
        return;
      }
      // 非水平模式时
      const latestOpenKey = openKeys.find((key) => !this.openKeys.includes(key));
      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    updateMenu() {
      const url = this.$route.path;
      let openKeys = [];
      const curInfo = this.normalMenu.find((item) => item.url === url);
      // 针对部分可以打开新标签的新增，修改，详情，不做处理
      if (!curInfo) {
        this.selectedKeys = [];
        this.openKeys = [];
        return;
      }
      if (this.mode === 'inline') {
        openKeys = [curInfo.id, ...findKeys(this.normalMenu, curInfo.parentId)];
      }
      // openKeys 是所有链路数据
      // openKeys =  [100343, 10034, 1003]
      // this.openKeys = [100343, 10034, 1003];
      // this.selectedKeys = [100343];
      this.selectedKeys = [curInfo.id];
      if (this.collapsed) {
        this.cachedOpenKeys = openKeys;
      } else {
        this.openKeys = openKeys;
      }
      // const routes = this.$route.matched.concat();
      // const { hidden } = this.$route.meta;
      // if (routes.length >= 3 && hidden) {
      //   routes.pop();
      //   this.selectedKeys = [routes[routes.length - 1].path];
      // } else {
      //   this.selectedKeys = [routes.pop().path];
      // }
      // const openKeys = [];
      // if (this.mode === 'inline') {
      //   routes.forEach((item) => {
      //     openKeys.push(item.path);
      //   });
      // }

      // if (this.collapsed) {
      //   this.cachedOpenKeys = openKeys;
      // } else {
      //   this.openKeys = openKeys;
      // }
    },

    // render
    renderItem(menu) {
      if (!menu.hidden) {
        return menu.children && !menu.hideChildrenInMenu
          ? this.renderSubMenu(menu)
          : this.renderMenuItem(menu);
      }
      return null;
    },
    renderMenuItem(menu) {
      let target = null;
      // 外部地址，设置 target = '_blank';
      // const reg = /(http|https):\/\/([\w.]+\/?)\S*/;
      const reg = /(http|https):\/\//;
      if (reg.test(menu.url)) {
        target = '_blank';
      }

      const tag = (target && 'a') || 'router-link';
      const props = { to: { path: menu.url } };
      const attrs = { href: menu.url, target };

      if (menu.children && menu.hideChildrenInMenu) {
        // 把有子菜单的 并且 父菜单是要隐藏子菜单的
        // 都给子菜单增加一个 hidden 属性
        // 用来给刷新页面时， selectedKeys 做控制用
        menu.children.forEach((item) => {
          item.meta = Object.assign(item.meta, { hidden: true });
        });
      }
      return (
        <Item {...{ key: menu.id }} title={this.$t(menu.perms)}>
          <tag {...{ props, attrs }}>
            {this.renderIcon(menu.icon)}
            <span title={this.$t(menu.perms)}>{this.$t(menu.perms)}</span>
          </tag>
        </Item>
      );
    },
    renderSubMenu(menu) {
      const itemArr = [];
      if (!menu.hideChildrenInMenu) {
        menu.children.forEach((item) => itemArr.push(this.renderItem(item)));
      }
      return (
        <SubMenu {...{ key: menu.id }}>
          <span slot="title">
            {this.renderIcon(menu.icon)}
            <span title={this.$t(menu.perms)}>{this.$t(menu.perms)}</span>
          </span>
          {itemArr}
        </SubMenu>
      );
    },
    renderIcon(icon) {
      if (icon === '' || icon === undefined) {
        return null;
      }
      // 此处依赖于外部组件
      // 注册menu菜单组件，use.js
      // const IconMenu = Icon.createFromIconfontCN({
      //   /* 系统管理-菜单管理-左侧导航栏图标库 */
      //   scriptUrl: '//at.alicdn.com/t/font_1390312_wpthir8tam.js',
      // });
      // Vue.component('IconMenu', IconMenu);

      return <IconMenu type={icon} />;
      // const props = {};
      // if (typeof icon === 'object') {
      //   props.component = icon;
      // } else {
      //   props.type = icon;
      // }
      // return <Icon {...{ props }} />;
    },
    // end method
  },

  render() {
    const { mode, menu, theme } = this;
    // console.log(menu);
    const props = {
      mode,
      theme,
      openKeys: this.openKeys,
    };
    const on = {
      select: (obj) => {
        this.selectedKeys = obj.selectedKeys;
        this.$emit('select', obj);
      },
      openChange: this.onOpenChange,
    };

    const menuTree = menu.map((item) => {
      if (item.hidden) {
        return null;
      }
      return this.renderItem(item);
    });
    // {...{ props, on: on }}
    return (
      <Menu vModel={this.selectedKeys} {...{ props, on }}>
        {menuTree}
      </Menu>
    );
  },
};
